const getTranslatedNames = function replaceGenreNameWithTranslatedTerm(
  genres,
  translatedNames
) {
  genres.map(genre => {
    const renamed = genre;
    renamed.name = translatedNames[genre.key];
    return renamed;
  });
  return genres;
};

export default getTranslatedNames;
